import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bordentownConfig } from "./data";

export default function BordentownPage() {
  return <CityPageTemplate config={bordentownConfig} />;
}